let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3n7rj")).then(() => parcelRequire('e8vin'));